import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { IRequirementMast } from "../../../models/RequirementMast";
import { EmptyRequirement } from "../EmptyRequirement";
import { Form } from "./Form";
import { TableMy } from "./TableMy";
import { TableAll } from "./TableAll";
import { ProgressSpinner } from "primereact/progressspinner";
import Confetti from 'react-confetti';
import TextTransition from "react-text-transition";
import { Button } from "primereact/button";
import { ILogin } from "../../../models/Login";

export interface IModel {
    open: boolean,
    singleData: IRequirementMast
}

export const SalesRequirementMast = (permissions: { tab: number, is_Create?: boolean, is_Delete?: boolean, is_Update?: boolean, is_Export?: boolean, is_View?: boolean }) => {
    const [modal, setModal] = useState({ singleData: EmptyRequirement, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);
    const [spinner, setSpinner] = useState(false);
    const [celebrate, setCelebrate] = useState<boolean>(false);
    const [index, setIndex] = useState(0);

    const ShowCelebration = () => {
        setCelebrate(true); setTimeout(() => setCelebrate(false), 10000);
    }
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

    const TEXTS = ["You", "Did", "It!", `${loginObj.name}`, "Todays Target Completed"];

    const colors = ["#ff595e", "green", "#edae49"];

    const springConfig: any = { stiffness: 50, damping: 30 };

    useEffect(() => {
        if (celebrate) {
            const intervalId = setInterval(
                () => setIndex((index) => index + 1),
                2000
            );
            return () => { clearTimeout(intervalId); setIndex(0) }
        }
    }, [celebrate]);
    const hideDialog = () => {
        setModal({ singleData: EmptyRequirement, open: false });
    };

    useEffect(() => {
        if (loginObj.website_Settings.enable_Add_Req_Time == true) {
            const st = new Date();
            st.setHours(8, 55, 0, 0);
            const et = new Date();
            et.setHours(18, 0, 0, 0);
            const currentTime = new Date();
            if (currentTime < st || currentTime > et) {
                toast.current.show({ severity: 'error', detail: "You can post the requirements between 8:55 AM to 6:00 PM", life: 3000 });
            }
        }
    }, []);

    return (
        <>

            {spinner && <ProgressSpinner className="m-auto left-50 mt-8" />}
            {((permissions.is_Create || permissions.is_Update) && permissions.tab === 2) && <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} ShowCelebration={ShowCelebration}></Form>}
            {permissions.tab === 1 && <TableAll permissions={permissions} toast={toast} reload={reload} setReload={setReload} />}
            {permissions.tab === 2 && !spinner && <TableMy hideDialog={hideDialog} setSpinner={setSpinner} permissions={permissions} setModal={setModal} toast={toast} reload={reload} spinner={spinner} setReload={setReload} ShowCelebration={ShowCelebration} />}
            <Toast ref={toast} />
            {celebrate && (
                <Confetti
                    width={window.innerWidth}
                    height={window.innerHeight}
                    gravity={0.2}
                    numberOfPieces={3500}

                />
            )}
            <div style={{ position: "absolute", top: '50%', left: '50%', transform: " translate(-50%, -50%)" }}>
                {celebrate && (
                    <TextTransition className="m-6 " style={{ color: colors[index % colors.length], alignContent: "center" }} springConfig={springConfig}><h1 style={{ fontSize: '100px', alignContent: "center", marginLeft: "40px" }}>{TEXTS[index % TEXTS.length]}&#127881;</h1></TextTransition>
                )}
            </div>
        </>
    );
}
